import router from "@/router"
import Cookies from 'js-cookie'
import JSEncrypt from '@/utils/jsencrypt'

import { validationOrg, getMenus, getUserInfo, getObs,getCheckFunctionDeleteMobile } from "./service"

var encrypt= new JSEncrypt()

encrypt.setPrivateKey(process.env.VUE_APP_publicKey)

const getAuthMap = (menus = [], authMap = {}) => {
  try{
      return menus.reduce(
        (acc, cur) => {
          const { menuUrl, menus, icon } = cur || {}
            if (menus && menus.length) {
                acc[menuUrl] = menuUrl
                acc[icon] = icon
                return getAuthMap(menus, acc)
            } else {
                acc[menuUrl] = menuUrl
                acc[icon] = icon
                return acc
            }
        },
        authMap
    )
  }catch(err){
    return {}
  }
}

const state = () => ({
  orgInfo: {
    organizationName: ''
  }, // 机构信息
  userInfo: {
    realName: ''
  },
  delDtnPermissions:false,
  menus: [],
  taskVisible: false,
  collapsed: localStorage.getItem('menus-collapsed') === 'true' ? true : false,
  loginLoading: false,
  menusMap: {},
  permissionDisplay:false,
})

const mutations = {
  setOrg(state, payload) {
    state.orgInfo = payload
  },
  setUserInfo(state, payload) {
    state.userInfo = payload
  },
  setPermissionDisplay(state, payload){
    state.permissionDisplay = payload
  },
  setDelDtnPermissions(state, payload) {
    state.delDtnPermissions = payload
  },
  setCollapsed(state, payload) {
    state.collapsed = payload
    localStorage.setItem('menus-collapsed', payload)
  },
  setTaskVisible(state, payload) {
    state.taskVisible = payload
  },
  setLoginLoading(state, payload) {
    state.loginLoading = payload
  },
  setMenus(state, payload) {
    state.menus = payload || []
  },
  setMenusMap(state, payload) {
    state.menusMap = payload || {}
  }
}

const actions = {
  getOrgInfo: (context, flag) => {
      return validationOrg().then(org => {
        context.commit("setOrg", {...org})
        const localOrg = Cookies.get('EDU-ORGANIZATION')
        if (`${localOrg}` !== `${org?.organizationId}`) {
          Cookies.set('EDU-ORGANIZATION', org?.organizationId || '')
          sessionStorage.setItem("oldOrganization", org?.organizationId)
          // Cookies.set('EDU-ORGANIZATION', '')
          router.push("/home")
        }
      }).catch(() => {
        router.push("/home/noorg")
      }).finally(() => {
        context.commit("setLoginLoading", false)
        if (flag) {
          return false
        }
        getMenus().then(res => {
          context.commit("setMenus", res || [])
          const authMap = getAuthMap(res)
          context.commit("setMenusMap", authMap || {})
        })
        getUserInfo().then(res => {
          if(res.roleCode.length === 1 && res.roleCode[0]=== 'TEACHER'){
            context.commit("setPermissionDisplay", false)
          }else{
            context.commit("setPermissionDisplay", true)
          }
          getCheckFunctionDeleteMobile({mobile:res.userName}).then((val) => {
            context.commit("setDelDtnPermissions", val || {})
          })
          context.commit("setUserInfo", res || {})

        })
        getObs().then(res => {
          try {
            const tempKey = encrypt.decrypt(res)
            window.edu_encrypt_upload = tempKey ? JSON.parse(tempKey) : {}
          } catch (error) {
            window.edu_encrypt_upload = {
              accessKeyId: "ENYPSYRUXWAYYGIYXOJ0",
              accessKeySecret: "VjnPkIGibNlrmw9tQWLf4bTriVLPArXVTu9TFOsJ",
              bucketName: "xqb-dev",
              obsClient: "obs.cn-east-3.myhuaweicloud.com"
            }
          }
        })
      })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
